import { ThreadMessage } from "../../../types"
import { formatDateTimeFromISO } from "../../utils"
import { useAppDispatch } from "../../hooks"
import { setImagePreview } from "../../../redux/slices/conversations"
import { NEWLINE_PATTERN, TAKEOVER_PREFIX, URL_PATTERN } from "../../constants"

const wrapLinks = (message: string): string => {
  return message.replace(
    URL_PATTERN,
    '<a href="$1" class="text-blue-600 underline break-all" target="_blank">$1</a>'
  )
}

interface FormattedMessage {
  text: JSX.Element
  time: string
  isUser: boolean
  takeOverFlag: boolean
}

const useConversationFormatter = (message: ThreadMessage): FormattedMessage => {
  const dispatch = useAppDispatch()

  const openImagePreviewPanel = (url: string) => {
    dispatch(setImagePreview(url))
  }

  let Element: JSX.Element = <></>
  let messageContent = message.message
  let takeOverFlag = false
  if (messageContent.includes("[image:")) {
    const imageURL = messageContent.slice(7, -1)

    Element = (
      <img
        key={imageURL}
        className="max-w-full w-60 cursor-pointer"
        src={imageURL}
        alt="rate quote"
        onClick={() => openImagePreviewPanel(imageURL)}
      />
    )
  } else {
    messageContent = messageContent.replace(NEWLINE_PATTERN, "<br>")
    messageContent = wrapLinks(messageContent)
    if (messageContent.startsWith(TAKEOVER_PREFIX)) {
      messageContent = messageContent.substring(TAKEOVER_PREFIX.length)
      takeOverFlag = true
    }
    Element = (
      <p
        key={messageContent}
        dangerouslySetInnerHTML={{ __html: messageContent }}
      />
    )
  }
  return {
    text: Element,
    time: formatDateTimeFromISO(message.timestamp, "h:mm a EEE, M/d"),
    isUser: message.sender !== "system",
    takeOverFlag
  }
}

export default useConversationFormatter
